import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M10.704 4.45a.77.77 0 0 0-.768.62l-.18 1.04A4.3 4.3 0 0 0 7.38 7.98c-.59.965-.824 2.138-.824 3.328v1.65l-1.403 1.805a.72.72 0 0 0-.153.442v1.502c0 .41.348.742.778.742h1.866c.993 1.057 2.143 1.755 3.373 2.002q.486.099.982.1h.002q.495-.001.982-.1c1.23-.247 2.38-.945 3.373-2.002h1.866c.43 0 .778-.332.778-.742v-1.502a.72.72 0 0 0-.153-.442l-1.403-1.806v-1.649c0-1.188-.237-2.36-.827-3.325a4.3 4.3 0 0 0-2.374-1.872l-.18-1.04a.77.77 0 0 0-.767-.622zm3.854 13H9.442c.59.428 1.2.702 1.811.825q.372.075.747.076.375 0 .747-.076c.61-.123 1.222-.397 1.811-.826M11.212 6.813l.152-.88h1.272l.152.88a.76.76 0 0 0 .593.603c.893.196 1.496.665 1.893 1.314.409.67.615 1.56.615 2.577v1.894c0 .16.054.314.153.442l1.402 1.806v.515H6.556v-.515l1.402-1.806a.72.72 0 0 0 .153-.442v-1.894c0-1.022.205-1.912.613-2.58.395-.646.996-1.115 1.894-1.311a.76.76 0 0 0 .594-.603",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "bell"}) } }